export default __webpack_public_path__ + "static/char-thumb-15-2f33a14c9451efad6e756c878887dfee.png";